var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-app-search",
      attrs: { id: "form-search-popover" }
    },
    [
      _c(
        "div",
        {
          staticClass: "studio-page-header",
          class: { "studio-page-header-long": !_vm.is_sidebar_minimized }
        },
        [
          _c("h4", { staticClass: "title-tab-experience-manager" }, [
            _vm._v("ANALYTIC DASHBOARD")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "custom-search",
              attrs: { slot: "beforeFilter" },
              slot: "beforeFilter"
            },
            [
              _c(
                "b-form",
                { attrs: { inline: "" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn grey btn-import-form m__r--5",
                      on: { click: _vm.openAddCanvas }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus fa-lg" }),
                      _vm._v(" Add\n        ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      attrs: { inline: "" },
                      on: {
                        keypress: function($event) {
                          if (!("button" in $event) && $event.keyCode !== 13) {
                            return null
                          }
                          $event.preventDefault()
                          _vm.filter(_vm.filter_data)
                        }
                      }
                    },
                    [
                      _c("j-select", {
                        staticClass: "m__r--5",
                        attrs: {
                          options: _vm.options_search,
                          "error-required": false,
                          placeholder: "Filter By"
                        },
                        model: {
                          value: _vm.select_type,
                          callback: function($$v) {
                            _vm.select_type = $$v
                          },
                          expression: "select_type"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-form-input", {
                        ref: "filterInput",
                        staticStyle: { width: "250px", height: "35px" },
                        attrs: { placeholder: "Search" },
                        model: {
                          value: _vm.filter_data,
                          callback: function($$v) {
                            _vm.filter_data = $$v
                          },
                          expression: "filter_data"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "studio-page-content" },
        [
          _c("v-server-table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.load_first,
                expression: "load_first"
              }
            ],
            ref: "canvasTableComponent",
            staticClass: "jTable",
            attrs: { columns: _vm.columns, options: _vm.table_options },
            on: { loading: _vm.loading, loaded: _vm.loaded },
            scopedSlots: _vm._u([
              {
                key: "id",
                fn: function(props) {
                  return _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          _vm.openDetail(props.row)
                        }
                      }
                    },
                    [_vm._v("\n        " + _vm._s(props.row.id) + "\n      ")]
                  )
                }
              },
              {
                key: "name",
                fn: function(props) {
                  return _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          _vm.openDetail(props.row)
                        }
                      }
                    },
                    [_vm._v("\n        " + _vm._s(props.row.name) + "\n      ")]
                  )
                }
              },
              {
                key: "created_at",
                fn: function(props) {
                  return _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          _vm.openDetail(props.row)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.convertTimestamp(props.row.created_at)) +
                          "\n      "
                      )
                    ]
                  )
                }
              },
              {
                key: "updated_at",
                fn: function(props) {
                  return _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          _vm.openDetail(props.row)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.convertTimestamp(props.row.updated_at)) +
                          "\n      "
                      )
                    ]
                  )
                }
              }
            ])
          }),
          _vm._v(" "),
          !_vm.load_first ? _c("jLoadingTable") : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "searchFormModal",
          attrs: {
            show: _vm.popoverSearchShow,
            container: "form-search-popover",
            target: "targetSearch",
            placement: "right"
          },
          on: {
            "update:show": function($event) {
              _vm.popoverSearchShow = $event
            }
          }
        },
        [
          _c("div", { staticClass: "m__b--10" }, [_vm._v("Search Data")]),
          _vm._v(" "),
          _c(
            "b-form",
            {
              attrs: { inline: "" },
              on: {
                keypress: function($event) {
                  if (!("button" in $event) && $event.keyCode !== 13) {
                    return null
                  }
                  $event.preventDefault()
                  _vm.filter(_vm.filter_data)
                }
              }
            },
            [
              _c("j-select", {
                staticClass: "m__r--5",
                attrs: { disabled: false, options: _vm.options_search },
                model: {
                  value: _vm.select_type,
                  callback: function($$v) {
                    _vm.select_type = $$v
                  },
                  expression: "select_type"
                }
              }),
              _vm._v(" "),
              _c("j-input", {
                staticClass: "m__r--5",
                attrs: { placeholder: "Search" },
                model: {
                  value: _vm.filter_data,
                  callback: function($$v) {
                    _vm.filter_data = $$v
                  },
                  expression: "filter_data"
                }
              }),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "btn blue outline",
                  staticStyle: { "margin-top": "-19px" },
                  on: {
                    click: function($event) {
                      _vm.filter(_vm.filter_data)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-search bold" }),
                  _vm._v(" Search\n      ")
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appAddCanvasModal",
          staticClass: "mod-form modal-add-form-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("CREATE CANVAS")
          ]),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.canvas_data.name.$error } },
            [
              _c("label", [_vm._v(" Name ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: {
                  "error-required": _vm.$v.canvas_data.name.$error,
                  "max-length": 255
                },
                model: {
                  value: _vm.$v.canvas_data.name.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.canvas_data.name, "$model", $$v)
                  },
                  expression: "$v.canvas_data.name.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.canvas_data.description.$error } },
            [
              _c("label", [_vm._v(" Description ")]),
              _vm._v(" "),
              _c("j-textarea", {
                attrs: {
                  "error-required": _vm.$v.canvas_data.description.$error
                },
                model: {
                  value: _vm.$v.canvas_data.description.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.canvas_data.description, "$model", $$v)
                  },
                  expression: "$v.canvas_data.description.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: { click: _vm.closeAddCanvas }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.createNewCanvas }
                      },
                      [_vm._v("\n            Next\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-233e79fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-233e79fa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/canvas/jCanvasList.vue
// module id = null
// module chunks = 